import { createClient } from "@/lib/supabase/client";

/**
 * 서버(api/)가 꼭 필요한 호출(노트 분석·업로드, 임베딩 검색, 회원 탈퇴)용 fetch.
 * 로그인 세션의 access token을 `Authorization: Bearer`로 실어 보낸다 — 예전에는 브라우저가 쿠키를
 * 자동으로 실어 보냈지만 이제는 서버가 쿠키 세션을 안 읽는다. getSession()은 만료가 가까우면
 * 토큰을 먼저 갱신해서 돌려준다.
 *
 * 주소는 기본이 같은 출처의 /api다(개발: Vite 프록시, 운영: CloudFront·Caddy가 /api/*를 API 원본으로
 * 라우팅). API를 다른 도메인에 두면 VITE_API_BASE_URL을 설정하고 API 쪽에서 CORS_ALLOWED_ORIGINS를 연다.
 */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const { data } = await createClient().auth.getSession();
  const headers = new Headers(init.headers);
  if (data.session) headers.set("Authorization", `Bearer ${data.session.access_token}`);

  const base = import.meta.env.VITE_API_BASE_URL ?? "";
  return fetch(`${base}${path}`, { ...init, headers });
}
